import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { assertString } from "../utils/assertions";
import { nowIso } from "../utils/timestamps";

export const createVesselParticulars = ({
  vesselId,
  identifiers = {},
  dimensions = {},
  capacities = {},
  performance = {},
  owner = {},
  operator = {},
  updatedAt = nowIso(),
  schemaVersion = SCHEMA_VERSIONS.VESSEL_PARTICULARS,
}) => {
  assertString(vesselId, "vesselParticulars.vesselId");

  return {
    vesselId,
    identifiers,
    dimensions,
    capacities,
    performance,
    owner,
    operator,
    updatedAt,
    schemaVersion,
  };
};
